import { SetupContext, computed, useRouter } from '@nuxtjs/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

const { useGetters, useActions, useState } = createNamespacedHelpers('biura');

interface IBiuraWyszukiwarkaService {
  emit: SetupContext['emit'];
}
const useBiuraWyszukiwarkaService = (params: IBiuraWyszukiwarkaService) => {
  const { emit } = params;
  const { wojewodztwa, miasta, koordynatyNaMape } = useGetters(['wojewodztwa', 'miasta', 'koordynatyNaMape']);

  const { miasto, wojewodztwo } = useState(['miasto', 'wojewodztwo', 'routeInfo']);

  const { localiseSuccess, changeDropdownWojewodztwo, changeDropdownMiasto } = useActions([
    'localiseSuccess',
    'initialize',
    'changeDropdownWojewodztwo',
    'changeDropdownMiasto',
  ]);

  const shouldDisableMiastaSelect = (): boolean => !miasta.value?.find((x) => x.Wartosc);

  const router = useRouter();

  return {
    miasto,
    wojewodztwo,
    miasta,
    wojewodztwa,
    toggleMap: () => {
      emit('toggleMap');
    },
    changeDropdownWojewodztwo: async (e: unknown) => {
      await changeDropdownWojewodztwo(e);
      router.push('/biura');
    },
    changeDropdownMiasto: async (e: unknown) => {
      await changeDropdownMiasto(e);
      miasto.value?.Wartosc ? router.push(`/biura/${miasto.value?.Wartosc}`) : router.push('/biura');
    },
    localise: () => {
      if (!process.client) return;

      window.navigator.geolocation.getCurrentPosition(
        (result) => localiseSuccess(result),
        (err) => console.log('err ', err),
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        },
      );
    },
    miastaSelectClass: computed(
      () => `biura__wyszukiwarka-input-wrap-item${shouldDisableMiastaSelect() ? ' biura__wyszukiwarka-input-wrap-item--disabled' : ''}`,
    ),
    shouldShowZnajdzBiuroNaMapieBtn: computed(() => koordynatyNaMape.value && koordynatyNaMape.value.length),
  };
};
export default useBiuraWyszukiwarkaService;
